import { render, staticRenderFns } from "./WithFilter.vue?vue&type=template&id=55f96cf4&scoped=true&"
import script from "./WithFilter.vue?vue&type=script&lang=js&"
export * from "./WithFilter.vue?vue&type=script&lang=js&"
import style0 from "./WithFilter.vue?vue&type=style&index=0&id=55f96cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f96cf4",
  null
  
)

export default component.exports